"use client";
import React, { useState } from "react";
import BlueHeading from "../other/common/BlueHeading";
import CustomButton from "../other/common/CustomButton";
import deepakSharmaImg from "../../assets/images/webp/other/deepak-sharma-two.webp";

const AboutContact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [errors, setErrors] = useState({
    name: "",
    email: "",
    message: "",
  });

  const validateForm = () => {
    let tempErrors = { name: "", email: "", message: "" };
    let isValid = true;

    // Validate name
    if (!formData.name) {
      tempErrors.name = "First Name is required";
      isValid = false;
    }

    // Validate email
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!formData.email) {
      tempErrors.email = "Email is required";
      isValid = false;
    } else if (!emailPattern.test(formData.email)) {
      tempErrors.email = "Please enter a valid email";
      isValid = false;
    }

    // Validate message
    if (!formData.message) {
      tempErrors.message = "Message cannot be empty";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      console.log("Form submitted", formData);
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  return (
    <>
      <div className="bg-[#EAF3EE] xl:pb-80 pb-60">
        <div className="container mx-auto 2xl:max-w-[1300px]">
          <div className="flex items-center justify-between max-[1320px]:gap-10 max-lg:flex-wrap-reverse">
            <div className="container max-xl:py-8">
              <BlueHeading lineClassOne="hidden" text="Contact Us" />
              <h2 className="text-[#001A3D] text-[50px] max-lg:text-4xl max-md:text-3xl font-bold leading-[120%] ff-jakarta">
                Contact / Connect
              </h2>
              <p className="text-[#3B3B3B] font-normal text-base leading-[150%]">
                Book Deepak Sharma for Talks, Seminars, or Interviews
              </p>
              <form
                onSubmit={handleSubmit}
                className="w-full min-w-[575px] max-[1320px]:min-w-[500px] max-sm:min-w-[320px]"
              >
                <div className="flex flex-col mt-3">
                  <label
                    htmlFor="name"
                    className="text-base font-normal ff-jakarta text-[#010101]"
                  >
                    First Name
                  </label>
                  <input
                    id="name"
                    type="text"
                    value={formData.name}
                    onChange={handleChange}
                    className={`border border-solid rounded-lg border-[#DDDDDD] bg-white outline-none focus:ring-2 focus:ring-[#16116D] w-full max-w-[575px]  h-[66px] max-sm:h-[40px] ${
                      errors.name ? "border-red-500" : ""
                    }`}
                  />
                  {errors.name && (
                    <p className="text-red-500 text-sm">{errors.name}</p>
                  )}
                </div>
                <div className="flex flex-col my-3">
                  <label
                    htmlFor="email"
                    className="text-base font-normal ff-jakarta text-[#010101]"
                  >
                    Email
                  </label>
                  <input
                    id="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    className={`border border-solid rounded-lg border-[#DDDDDD] max-sm:h-[40px] bg-white outline-none focus:ring-2 focus:ring-[#16116D] w-full max-w-[575px] h-[66px] ${
                      errors.email ? "border-red-500" : ""
                    }`}
                  />
                  {errors.email && (
                    <p className="text-red-500 text-sm">{errors.email}</p>
                  )}
                </div>
                <div className="flex flex-col">
                  <label
                    htmlFor="message"
                    className="text-base font-normal ff-jakarta text-[#010101]"
                  >
                    Message
                  </label>
                  <textarea
                    id="message"
                    value={formData.message}
                    onChange={handleChange}
                    className={`w-full max-w-[575px] h-[144px] rounded-lg bg-white border border-solid border-[#DDDDDD] outline-none focus:ring-2 focus:ring-[#16116D] ${
                      errors.message ? "border-red-500" : ""
                    }`}
                  ></textarea>
                  {errors.message && (
                    <p className="text-red-500 text-sm">{errors.message}</p>
                  )}
                </div>
                <CustomButton
                  text="Visit Makeway India"
                  submit="submit"
                  myClass="mt-10 max-sm:mt-6"
                />
              </form>
            </div>
            <img
              src={deepakSharmaImg}
              alt="deepak-sharma"
              width={657}
              height={732}
              className="w-full max-w-[657px] max-[1320px]:max-w-[450px] max-[1320px]:mx-auto pointer-events-none"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutContact;
